// extracted by mini-css-extract-plugin
export var container = "_b1-0";